import { MapContainer, TileLayer, CircleMarker, Circle, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { ExternalLink } from "lucide-react";

const ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const mapsUrl = (lat, lng, label = "") => (/iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && "ontouchend" in document
  ? `https://maps.apple.com/?ll=${lat},${lng}&q=${encodeURIComponent(label || "Location")}`
  : `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`);

export const OpenInMaps = ({ lat, lng, label, testid }) => (
  <a href={mapsUrl(lat, lng, label)} target="_blank" rel="noreferrer" className="inline-flex min-h-[44px] items-center gap-1 text-xs font-semibold text-q-muted underline" data-testid={testid}>
    <ExternalLink className="h-3 w-3" /> Open in Maps</a>
);

function Picker({ onPick }) {
  useMapEvents({ click: (e) => onPick({ lat: e.latlng.lat, lng: e.latlng.lng }) });
  return null;
}

export function LocMap({ lat, lng, radius, height = 160, onPick, zoom = 15, testid = "loc-map" }) {
  const has = lat != null && lng != null;
  const c = has ? [lat, lng] : [40.6782, -73.9442];
  return (
    <div className="isolate overflow-hidden rounded-2xl border border-q-line" style={{ height }} data-testid={testid}>
      <MapContainer key={`${c[0]},${c[1]}`} center={c} zoom={has ? zoom : 11} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution={ATTR} url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {has && radius && <Circle center={c} radius={radius} pathOptions={{ color: "#f97316", weight: 1, fillOpacity: 0.12 }} />}
        {has && <CircleMarker center={c} radius={8} pathOptions={{ color: "#fff", weight: 2, fillColor: "#f97316", fillOpacity: 1 }} />}
        {onPick && <Picker onPick={onPick} />}
      </MapContainer>
    </div>
  );
}
